<app-header2></app-header2>
<div style="padding-top: 56px;">
    <router-outlet></router-outlet>
</div>